<script lang="ts">
	import type { SbImage } from '../types';
	import SbRichtext from '../components/sbRichtext.svelte';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';

	interface Props {
		content: ISbStoryData<{
			icon: SbImage;
			title: string | ISbRichtext;
			subtitle: string | ISbRichtext;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div
	use:editable={content}
	class="flex h-full flex-col justify-between rounded-xl border-[0.5px] border-stone-2 px-4 py-3 text-brown-1"
>
	<img
		loading="lazy"
		class="h-12 w-12 object-cover"
		src={content.icon?.filename}
		alt={content.icon?.alt ?? ''}
		title={content.icon?.title ?? ''}
		height={48}
		width={48}
	/>
	<div class="mt-4 lg:mt-6">
		<div class="text-[20px]/[110%] font-semibold"><SbRichtext text={content.title} /></div>
		<div class="mt-1 text-[16px]/[140%] text-brown-3 lg:text-[18px]">
			<SbRichtext text={content.subtitle} />
		</div>
	</div>
</div>
